import { ConnectionFlight } from "../types";

// Parse an "HH:MM:SS" / "HH:MM" duration string to total minutes.
export const durationToMinutes = (raw?: string): number => {
  if (!raw) return 0;
  const parts = raw.split(":");
  const h = parseInt(parts[0], 10) || 0;
  const m = parseInt(parts[1], 10) || 0;
  return h * 60 + m;
};

// Format a minute count as "20h 55m" (matches the segment/layover style on
// the search-results page). Handles totals over 24h.
export const formatMinutes = (total: number): string => {
  const hours = Math.floor(total / 60);
  const minutes = total % 60;
  if (hours && minutes) return `${hours}h ${minutes}m`;
  if (hours) return `${hours}h`;
  return `${minutes}m`;
};

// Compute a connection's total (gate-to-gate) duration from its segments and
// layover. We do NOT use connection.totalDuration because the backend formats
// it as a 24h clock time, so any trip over 24h wraps (e.g. 26h45m -> 2h45m).
export const getConnectionTotalDuration = (
  connection: ConnectionFlight,
): string => {
  const segmentMinutes = connection.segments.reduce(
    (sum, segment) => sum + durationToMinutes(segment.duration),
    0,
  );
  return formatMinutes(segmentMinutes + (connection.layoverMinutes || 0));
};
